import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Mixins, Prop } from "vue-property-decorator";
// S1
import BaseMixer from "@/router/views/BaseMixer";
import VueApexChart from "vue-apexcharts";
let EcRadialBar = /** @class */ (() => {
    let EcRadialBar = class EcRadialBar extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.radialBar = {
                options: {
                    chart: {
                        // width: 70,
                        // height: 70,
                        type: "radialBar",
                        fontFamily: '"Poppins", sans-serif',
                    },
                    plotOptions: {
                        radialBar: {
                            hollow: {
                                margin: 0,
                                size: "65%",
                            },
                            track: {
                                show: true,
                                background: "#f2f2f2",
                                strokeWidth: "95%",
                                opacity: 1,
                                margin: 0,
                                dropShadow: {
                                    enabled: false,
                                },
                            },
                            dataLabels: {
                                showOn: "always",
                                name: {
                                    show: false,
                                },
                                value: {
                                    offsetY: 3,
                                    color: "#495057",
                                    fontSize: "13px",
                                    show: true,
                                },
                            },
                        },
                    },
                    series: [0],
                    stroke: {
                        lineCap: "round",
                    },
                },
            };
        }
        created() {
            this.radialBar.options.series = this.series;
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", Array)
    ], EcRadialBar.prototype, "series", void 0);
    EcRadialBar = __decorate([
        Component({
            name: "EcRadialBar",
            components: {
                VueApexChart,
            },
        })
    ], EcRadialBar);
    return EcRadialBar;
})();
export default EcRadialBar;
